<!-- 广州致信签 -->
<template>
  <div class="login" :style="{minHeight: height}">
    <el-card shadow="never" :class="['card',{'margin-none':isIframe}]" ref="referenceCard">
      <div class="login-logo">
        <a href="https://www.forchain.com.cn">
          <img class="logo-1" src="/images/gzzx/logo.png" alt="">
          <img src="/images/login_slogan.png" alt="">
        </a>
      </div>
      <el-form :model="formData" size="small" label-position="right" :rules="rules" ref="form" class="form">
        <el-form-item prop="username" style="margin-bottom: 30px">
          <el-input v-model="formData.username" auto-complete="off" placeholder="请输入手机号/邮箱">
            <i @click="formData.username = ''" slot="suffix" class="el-input__icon el-icon-error"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" style="margin-bottom: 30px">
          <el-input ref="passwordInput" :type="viewPassword" v-model="formData.password" auto-complete="off"
            placeholder="请输入密码">
            <template slot="suffix">
              <i @click="viewPassword='text'" v-if="viewPassword === 'password'" class="eyes-close"></i>
              <i @click="viewPassword='password'" v-if="viewPassword === 'text'" class="eyes-open"></i>
            </template>
          </el-input>
        </el-form-item>
        <template v-if="imgAuth.show">
          <el-form-item prop="imgAuth">
            <el-input ref="imgAuthInput" v-model="formData.imgAuth" auto-complete="off" placeholder="验证码">
              <template slot="append">
                <div @click="getImgAuth" class="img-code">
                  <img :src="'data:image/jpeg;base64,'+imgAuth.imgPath" />
                </div>
              </template>
            </el-input>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button @click.prevent="submit" class="btn-submit" type="primary" style="width: 100% ;font-size: 14px;"
            native-type="submit">登录
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-row class="text-right">
            <nuxt-link class="link-btn" :to="{path: '/account/forgetPwd', query: {tag: 'mobile'}}" :target="isIframe?'_self':'_blank'">忘记密码？
            </nuxt-link>
            <nuxt-link :to="{path:'/account/register-gzzx',query:{si:'262C83178084DF375AF1A3D6DC3A2E4A'}}" class="link-btn">新用户注册</nuxt-link>
          </el-row>
        </el-form-item>

      </el-form>
    </el-card>
  </div>
</template>

<script>
  import {
    postLogin,
    postImgCode,
    profile,
    ApiMethods
  } from '../../assets/js/http-serve/http-methods';
  import {
    password,
    imgAuth,
    username
  } from '../../assets/js/lib/valid-methods';
  import {
    loginOrRefresh
  } from '../../assets/js/http-serve/corp/common';
  import GlobalConfig from '@/assets/js/config/global';
  import md5 from 'js-md5';
  import sha512 from 'js-sha512';

  let base64 = require('js-base64').Base64;

  export default {
    name: 'index',
    layout: 'user',
    head() {
      return {
        title: this.title
      }
    },
    data() {
      return {
        title: '登录',
        junziqanIndex: GlobalConfig.domain.junziqanIndex,
        downloadJunzidun: GlobalConfig.domain.junziqianApi + '/www/君子盾控件.exe',
        formData: {
          username: '',
          password: '',
          imgCode: null,
          imgAuth: ''
        },
        rules: {
          password: [{
            validator: password,
            trigger: 'blur'
          }],
          imgAuth: [{
            validator: imgAuth,
            trigger: 'blur'
          }]
        },
        imgAuth: {
          imgToken: null,
          imgPath: null,
          show: false
        },
        userType: 'person',
        viewPassword: 'password',
        height: '877px',
        isIframe: false,
      };
    },
    mounted() {
      this.isIframe = window !== window.top;
      this.height = (document.body.clientHeight || window.document.body.clientHeight) + 'px';
      window.localStorage.setItem('login-path', this.$route.path);
      this.computeMargin();
      if (this.$route.query && this.$route.query.account) {
        this.formData.username = this.$route.query.account;
      }
    },
    created() {},
    methods: {
      // 添加百度统计按钮事件埋点
      gotoRegister() {
        window._hmt = window._hmt || []
        window._hmt.push(['_trackEvent', '点击注册按钮', 'click'])
      },
      computeMargin() {
        let height = (document.body.clientHeight || window.document.body.clientHeight)
        if (height > 553 && this.$refs.referenceCard && this.$refs.referenceCard.$el) {
          let element = this.$refs.referenceCard.$el
          let margin = (height - 553) / 2
          element.style.marginTop = margin + 'px'
        } else {
          let element = this.$refs.referenceCard.$el
          element.style.marginTop = '0px'
        }
        // add listen
        window.onresize = () => {
          let height = (document.body.clientHeight || window.document.body.clientHeight)
          if (this.$refs.referenceCard) {
            if (height > 553 && this.$refs.referenceCard && this.$refs.referenceCard.$el) {
              let element = this.$refs.referenceCard.$el
              let margin = (height - 553) / 2
              element.style.marginTop = margin + 'px'
            } else {
              let element = this.$refs.referenceCard.$el
              element.style.marginTop = '0px'
            }
          }
        }
      },
      submit: function() {
        var _this = this;
        _this.$refs.form.validate(val => {
          if (val || val === 'true') {
            let loading = _this.$loading({
              lock: true,
              text: '正在登录',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, .5)'
            });

            if (_this.formData.imgAuth) {
              _this.formData.imgCode = `${_this.imgAuth.imgToken}_${_this.formData.imgAuth}`;
            }

            var param = {
              account: _this.formData.username.trim(),
              password: sha512(
                _this.formData.username.trim() + md5(_this.formData.password)),
              tokenValiCode: _this.formData.imgCode
            };
            ApiMethods.AccountLoginController.ssoLogin(param).then(async result => {
              loading.close();
              if (result.success) {
                var s=result.data.s;
                var t=result.data.t;
                var ap = encodeURIComponent(_this.$route.query.ap || "/viewIndex");
                var cp = encodeURIComponent(GlobalConfig.domain.junziqianWebOp+"/login/authorize");
                let signUrl = localStorage.getItem('sign-url');
                if (signUrl) {
                  ap = encodeURIComponent(signUrl);
                  localStorage.removeItem('sign-url');
                }
                window.location.href = GlobalConfig.domain.accountWeb + "/login/authentication?ap="+ap+"&cp="+cp+"&t="+t+"&s="+s;
              } else if (result.code == 60101003) {
                _this.$message.error('请输入正确的验证码');
                _this.formData.imgAuth = '';
                _this.getImgAuth();
              } else if (result.code == 60102201) {
                _this.$message.error(result.message || '账户名或密码不正确');
                _this.formData.password = '';
                _this.$refs.passwordInput.$el.querySelector('input').focus();
                _this.formData.imgAuth = '';
                _this.getImgAuth();
              } else {
                _this.$message.error(result.message || '登录失败');
                _this.formData.password = '';
                _this.$refs.passwordInput.$el.querySelector('input').focus();
                if (_this.imgAuth.show) {
                  _this.formData.imgAuth = '';
                  _this.getImgAuth();
                }
              }
            }).catch(error => {
              loading.close();
            });

          }
        });
      },
      getImgAuth: function() {
        postImgCode(1).then(({
          data
        }) => {
          this.imgAuth = data;
          this.imgAuth.show = true;
        });
      },
      wxLogin: function() {
        var url = this.$route.query.returnURL || window.location.origin +
          '/viewIndex';
        var bindUrl = GlobalConfig.domain.accountWeb +
          '/account/bindUserPage?returnURL=' + url + '&scene=304';
        window.location.href = GlobalConfig.domain.accountWeb +
          '/binding/toWechatAuth?abt=3&scene=304&returnURL=' + encodeURIComponent(url) +
          '&bindUrl=' + encodeURIComponent(bindUrl);
      },
      qqLogin: function() {
        var url = this.$route.query.returnURL || window.location.origin +
          '/viewIndex';
        window.location.href = GlobalConfig.domain.accountWeb +
          '/binding/toQqLogin?returnURL=' + encodeURIComponent(url) + '&type=1&scene=302';
      },
      sinaLogin: function() {
        var url = this.$route.query.returnURL || window.location.origin +
          '/viewIndex';
        window.location.href = GlobalConfig.domain.accountWeb +
          '/binding/toWebLogin?returnURL=' + encodeURIComponent(url) +
          '&type=1&scene=303';
      }
    }
  };
</script>
<style>
  .el-input-group__append {
    background-color: #c0c4cc !important;
    border-color: #c0c4cc !important;
  }
</style>
<style lang="less" scoped>
  .login {
    background: #FFFFFF url("/images/gzzx/bg.png") no-repeat;
    background-size: cover;
  }

  .margin-none {
    margin: 0 auto !important;
  }

  .link-btn {
    border-right: 1px solid #aaa;
    display: inline-block;
    height: 16px;
    padding: 0 15px;
    line-height: 16px;

    &:last-child {
      border-right: none;
    }
  }

  .list-table {
    padding: 0;
    display: table;
    width: 100%;

    li {
      display: table-cell;
      vertical-align: top;
    }

    .line-gray {
      display: inline-block;
      border-bottom: 1px solid #bfbfbf;
      margin-top: 9px;
      width: 140px;
    }
  }

  .list-3thdAcount {
    width: 60%;
    position: relative;
    left: 50%;
    transform: translateX(-50%);

    .wx {
      background-image: url('/images/login/oacount_wx.jpg');
    }

    .qq {
      /*background-image: url('/images/login/oacount_qq.jpg');*/
      background-image: url('/images/login/oacount_qq.png');
    }

    .sina {
      /*background-image: url('/images/login/oacount_sina.jpg');*/
      background-image: url('/images/login/oacount_sina.png');
    }

    a span {
      display: inline-block;
      height: 36px;
      width: 36px;
      background-repeat: no-repeat;
      background-size: contain;
      border-radius: 50%;
      vertical-align: middle;
      margin-right: 6px;
    }
  }

  .login {
    width: 100%;
    min-height: 100%;

    /**
      new style of password change icon
    */
    .eyes-open,
    .eyes-close {
      width: 20px;
      height: 12px;
      display: inline-block;
      cursor: pointer;
    }

    .eyes-open {
      background: url('/static/images/eyes-open.png') no-repeat;
    }

    .eyes-close {
      background: url('/static/images/eyes-close.png') no-repeat;
    }

    .card {
      box-sizing: border-box;
      max-width: 540px;
      // margin: 180px auto 0;
      margin: auto;
      padding: 20px 50px 40px 50px;
      background: rgba(255, 2555, 255, 0.6);

      .form {
        .img-code {
          background-color: white;
          display: inline-block;
          margin: 0 -20px;
          width: 100px;
          line-height: 30px;
          text-align: center;
          cursor: pointer;

          img {
            vertical-align: middle;
            display: inline-block;
            height: 27px;
            width: 100%;
          }
        }
      }

      .login-logo {
        margin: 30px 0px 10px 0px;

        .logo-1 {
          margin-bottom: 20px;
        }

        img {
          position: relative;
          transform: translateX(-50%);
          left: 50%;
          max-width: 100%;
          display: block;
        }
      }
    }

    .header {
      border-bottom: 1px solid #cccccc;

      p {
        height: 58px;
        line-height: 58px;
        max-width: 1200px;
        margin: 0 auto;

        img {
          height: 32px;
        }
      }
    }
  }

  .btn-submit {
    background-color: #00599f;
    border-color: #00599f;

    &:hover,
    &:focus {
      background-color: rgba(0, 89, 159, 0.9);
      border-color: rgba(0, 89, 159, 0.9);
    }
  }
</style>



// WEBPACK FOOTER //
// pages/login-gzzx/index.vue